import { Carousel } from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'

import './carousel.css'

const CarouselComponent = () => {
    return (
        <Carousel fade={true} controls={false} className="carousel">
            <Carousel.Item interval={3000}>
                <img
                className="d-block w-100"
                src="assets/carousel/spring.jpg"
                alt="First slide"
                />
            </Carousel.Item>
            <Carousel.Item interval={3000}>
                <img
                className="d-block w-100"
                src="assets/carousel/snow.jpg"
                alt="Second slide"
                />
            </Carousel.Item>
            <Carousel.Item interval={3000}>
                <img
                className="d-block w-100"
                src="assets/carousel/sea.jpg"
                alt="Third slide"
                />
            </Carousel.Item>
        </Carousel>
    )
}

export default CarouselComponent
